export const Logo = ({ small }) => (
  <a
    href="#top"
    data-testid="logo-link"
    onClick={(e) => {
      e.preventDefault();
      if (window.__lenis) window.__lenis.scrollTo(0);
      else window.scrollTo({ top: 0, behavior: "smooth" });
    }}
    className="flex items-center gap-2.5"
    aria-label="Orqestria"
  >
    <svg
      width={small ? 26 : 30}
      height={small ? 26 : 30}
      viewBox="0 0 64 64"
      className="shrink-0"
      aria-hidden="true"
    >
      <path d="M32 9 a23 23 0 1 0 23 23" fill="none" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" />
      <path d="M50 20 a19 19 0 0 0 -14 -6" fill="none" stroke="#39FF14" strokeWidth="6" strokeLinecap="round" />
      <circle cx="32" cy="32" r="8" fill="#00E5FF" />
    </svg>
    <span className="font-display text-xl font-extrabold tracking-tight text-white">
      orqestria<span className="text-volt">.</span>
    </span>
  </a>
);
